export default "__VITE_ASSET__CviDRz15__"